// This code should be added to your theme.js file or as a separate JavaScript file
document.addEventListener('DOMContentLoaded', function() {
  // Get the form element
  const filterForm = document.querySelector('.hero-filter-form');
  
  if (filterForm) {
    filterForm.addEventListener('submit', function(event) {
      event.preventDefault();
      
      // Get the selected values
      const filterType = document.querySelector('input[name="filter-type"]:checked').value;
      const gemstone = document.getElementById('gemstone-select').value;
      const caratWeight = document.getElementById('carat-select').value;
      const price = document.getElementById('price-select').value;
      
      // Base URL for collections
      let redirectUrl = '/collections/';
      
      // Determine which collection to show based on selections
      if (filterType === 'gemstone') {
        // If gemstone is selected, use that as the base collection
        redirectUrl += gemstone ? gemstone.toLowerCase().replace(/ /g, '-') : 'all';
      } else {
        // Otherwise use the purpose collection
        redirectUrl += 'by-purpose';
      }
      
      // Add filters as URL parameters
      const params = new URLSearchParams();
      
      if (caratWeight && caratWeight !== 'Select Carat Weight') {
        params.append('filter.v.meta.custom.carat_weight', caratWeight);
      }
      
      if (price && price !== 'Select Price') {
        // Assuming price has ranges like "₹1000-₹5000"
        const priceRange = price.replace('₹', '').split('-');
        if (priceRange.length === 2) {
          params.append('filter.v.price.gte', priceRange[0].trim());
          params.append('filter.v.price.lte', priceRange[1].replace('₹', '').trim());
        }
      }
      
      // Add parameters to URL if there are any
      const paramString = params.toString();
      if (paramString) {
        redirectUrl += '?' + paramString;
      }
      
      // Redirect to the collection page
      window.location.href = redirectUrl;
    });
  }
});


// // Sort products: In-stock first, out-of-stock last
// document.addEventListener('DOMContentLoaded', function() {
//   function sortProductsByStock() {
//     const productGrid = document.querySelector('.collection .grid, .product-grid, [data-id="product-grid"]');
    
//     if (!productGrid) return;
    
//     const products = Array.from(productGrid.children);
    
//     products.sort(function(a, b) {
//       const aOutOfStock = a.querySelector('.sold-out, .badge--sold-out, [data-sold-out="true"]') !== null;
//       const bOutOfStock = b.querySelector('.sold-out, .badge--sold-out, [data-sold-out="true"]') !== null;
      
//       if (aOutOfStock && !bOutOfStock) return 1;
//       if (!aOutOfStock && bOutOfStock) return -1;
//       return 0;
//     });
    
//     products.forEach(function(product) {
//       productGrid.appendChild(product);
//     });
//   }
  
//   // Initial sort
//   sortProductsByStock();
  
//   // Re-sort after filters applied
//   const observer = new MutationObserver(sortProductsByStock);
//   const targetNode = document.querySelector('.collection, #main-collection-product-grid');
  
//   if (targetNode) {
//     observer.observe(targetNode, { childList: true, subtree: true });
//   }
  
//   // Re-sort on facet filter change
//   document.addEventListener('click', function(e) {
//     if (e.target.closest('.facets, .filter')) {
//       setTimeout(sortProductsByStock, 500);
//     }
//   });
// });


